// JS
import React, { Suspense } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { useMediaQuery } from 'react-responsive';
import { ppHeadingOverridesClose } from '../shared/utils';

// COMP
import { LoadingSpinner } from '../LoadingSpinner';
import ProductShipping from '../ProductShipping';
import ProductReturns from '../ProductReturns';

// COMPONENT
const ProductShippingReturnsPopup = ({
  data,
  shippingInformation,
  returnsInformation,
  showHidePSR,
  setShowHidePSR
}) => {
  const closePSRCleanUp = () => {
    setShowHidePSR(false);
    window.scrollLock();
    ppHeadingOverridesClose();
  };

  // DEVICES
  const isMobile = useMediaQuery({ maxWidth: 767 });

  return (
    <>
      {showHidePSR && data && (
        <>
          <div
            id="psr-overlay"
            className={isMobile ? 'fade-in-up' : 'animate-fadeIn'}
            onClick={(e) => {
              if (e.currentTarget === e.target && !isMobile) {
                setTimeout(() => {
                  closePSRCleanUp();
                }, '400');
                document.getElementById('psr-overlay').className = isMobile
                  ? 'fade-out-down'
                  : 'animate-fadeOut';
                document.getElementById('psr-content').className = isMobile
                  ? ''
                  : 'fade-out-right';
              }
            }}
          >
            <div id="psr-content" className={isMobile ? '' : 'fade-in-left'}>
              <div className="psr-details">
                <div
                  id="psr-details-close"
                  onClick={() => {
                    setTimeout(() => {
                      closePSRCleanUp();
                    }, '400');
                    document.getElementById('psr-overlay').className = isMobile
                      ? 'fade-out-down'
                      : 'animate-fadeOut';
                    document.getElementById('psr-content').className = isMobile
                      ? ''
                      : 'fade-out-right';
                  }}
                ></div>
                <div className="psr-details-copy">
                  <Tabs>
                    <TabList>
                      <Tab>Shipping</Tab>
                      <Tab>Returns</Tab>
                    </TabList>
                    <TabPanel>
                      <Suspense fallback={<LoadingSpinner />}>
                        <ProductShipping data={shippingInformation} />
                      </Suspense>
                    </TabPanel>
                    <TabPanel>
                      <Suspense fallback={<LoadingSpinner />}>
                        <ProductReturns data={returnsInformation} />
                      </Suspense>
                    </TabPanel>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ProductShippingReturnsPopup;
